import React from 'react';
import { Header, EditProfileInfo, ProfileInfo } from 'widgets';
import { UserRoleEnum, userStore } from 'entities/index';
import { updateOwnerInfo } from 'features/index';
import { BusinessApi } from 'shared/api';
import { PageLayout } from 'shared/ui';
import { LicenseBuy } from 'widgets';

export const ProfilePage: React.FC = () => {
  const updateData = async (email: string, fio: string, phone: string) => {
    switch (userStore.role) {
      case UserRoleEnum.OWNER:
        await updateOwnerInfo(email, fio, phone);
        await userStore.init();
        break;
      case UserRoleEnum.ADMINISTRATOR:
        await BusinessApi.updateAdministratorInfo({
          adminId: userStore.id,
          email,
          fio,
          phone,
        });
        await userStore.init();

        break;
      case UserRoleEnum.MANAGER:
        await BusinessApi.updateManagerInfo({
          managerId: userStore.id,
          email,
          fio,
          phone,
        });
        await userStore.init();

        break;
      case UserRoleEnum.EMPLOYEE:
        await BusinessApi.updateEmployeeInfo({
          employeeId: userStore.id,
          email,
          fio,
          phone,
        });
        await userStore.init();
        break;
      default:
        break;
    }
  };

  return (
    <PageLayout>
      <Header />
      <ProfileInfo></ProfileInfo>
      <EditProfileInfo
        dataFio={userStore.fio}
        dataEmail={userStore.email}
        dataPhone={userStore.phone}
        updateData={updateData}
      ></EditProfileInfo>
      {userStore.role === UserRoleEnum.OWNER ? <LicenseBuy /> : null}
    </PageLayout>
  );
};
